import { connect } from 'react-redux';
import { registerPartner, getAllCompanyDomains } from 'redux/services/api/register';
import RegisterPartnerV2 from './register-partner-v2';

const mapStateToProps = (state) => ({
  success: state.api.register.success,
  companydomains: state.api.register.companydomains,
  portalUrl: state.appsettings.andromeda.portalUrl,
  privacyStatementForNetworkers:
    state.appsettings.privacyPolicy.privacyStatementForNetworkers,
});

const mapDispatchToProps = (dispatch) => ({
  register: (formData) => dispatch(registerPartner(formData)),
  getAllCompanyDomains: () => dispatch(getAllCompanyDomains()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPartnerV2);
